<mat-card class="cardWithShadow theme-card">
  <mat-card-content *ngIf="booleanFlag" class="b-t-1" id="chart-container">
    <h3>Factorizaciones Mensuales (por Docs)</h3>
    <apx-chart
      [series]="gredientChartOptions.series"
      [chart]="gredientChartOptions.chart"
      [stroke]="gredientChartOptions.stroke"
      [xaxis]="gredientChartOptions.xaxis"
      [fill]="gredientChartOptions.fill"
      [markers]="gredientChartOptions.markers"
      [yaxis]="gredientChartOptions.yaxis"
      [plotOptions]="gredientChartOptions.plotOptions"
      [tooltip]="gredientChartOptions.tooltip"
      [grid]="gredientChartOptions.grid"
      #chart
    >
    </apx-chart>
  </mat-card-content>
  <div class="spinner">
    <mat-spinner *ngIf="!booleanFlag"></mat-spinner>
  </div>
</mat-card>
